import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sqg-users" }
const _hoisted_2 = { class: "sqg-users__line" }
const _hoisted_3 = { class: "sqg-users__line" }
const _hoisted_4 = { class: "sqg-users__line" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1)
const _hoisted_6 = { class: "sqg-users__line" }
const _hoisted_7 = { class: "sqg-users__check" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" éléments sélectionnés ")
const _hoisted_9 = {
  key: 0,
  class: "sqg-users__actions"
}
const _hoisted_10 = { style: {"position":"relative","width":"100%"} }
const _hoisted_11 = {
  key: 0,
  class: "sqg-users__results"
}
const _hoisted_12 = {
  key: 0,
  class: "sqg-users__noResults"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Aucun utilisateurs ...")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "sqg-users__results"
}

import {computed, ComputedRef, onMounted, ref, watch} from "vue";
import {useUserStore} from "@/stores/user";
import User from "@/types/User";
import {storeToRefs} from "pinia";
import {useRoute} from "vue-router";
import {AxiosResponse} from "axios";
import {arrayHasBasedOnId, arrayToggleBaseOnId, isActionAvailable} from '@/functions/utils';
import Header from '@/components/Header.vue';
import CardButton from '@/components/CardButton.vue';
import CardFilter from '@/components/CardFilter.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Card from '@/components/Card.vue';
import Input from '@/components/Input.vue';
import CreateManager from '@/modales/CreateManager.vue';
import CreateClient from '@/modales/CreateClient.vue';
import CreateAdmin from '@/modales/CreateAdmin.vue';
import LinkUserToFolders from '@/modales/LinkUserToFolders.vue';
import ChangeLogin from '@/modales/ChangeLogin.vue';
import TableItem from '@/components/TableItem.vue';
import TableItemSkeleton from '@/components/TableItemSkeleton.vue';

//ROUTER

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

//STORE user
const usersStore = useUserStore();
const { user, userLoader } = storeToRefs(usersStore);

//DATA
const users = ref<Array<User>>([]);
const createUserModale = ref('');
const isLinkUserOpen = ref(false);
const isChangeLoginOpen = ref(false);
const userId = ref('');
const userObj = ref({});
const usersCheck = ref<Array<any>>([]);

//DISPLAY USERS
const searchTerm = ref('');
const roleFilters = ref<Array<String>>([]);
const filterBy = (type: Array<String>) => {
  if (isActive(type)) {
    roleFilters.value.splice(0,roleFilters.value.length);
  } else {
    roleFilters.value.splice(0,roleFilters.value.length);
    type.forEach(elem => roleFilters.value.push(elem));
  }
};
const isActive = (type: Array<String>) => {
  return type.every(elem => roleFilters.value.includes(elem));
};
const usersToDisplay: ComputedRef<Array<Object>> = computed(() => {
  let result = users.value;
  //FILTER
  if (searchTerm.value !== '') result = result.filter((user: User) => user.lastname.includes(searchTerm.value));
  if (roleFilters.value.length > 0) result = result.filter((user: User) => roleFilters.value.includes(user.role));
  //BUILD ITEM_TABLE
  return result.map((item) => {
    let actions = [] as Array<Object>;
    actions.push({ icon: 'fa-solid fa-eye', text: 'Voir', action: 'view' });
    switch (item.role) {
      case 'gestionnaireDeDossier':
        if (user.value.role !== 'gestionnaireDeDossier') actions.push({ icon: 'fas fa-folder-plus', text: 'Associer', action: 'link' });
        else actions.push({ action: 'empty' });
        break;
      case 'responsable':
        actions.push({ action: 'empty' });
        break;
      case 'admin':
        if (user.value.role === 'superAdmin') actions.push({ icon: 'fas fa-trash-alt', text: 'Supprimer', action: 'remove' });
        else actions.push({ action: 'empty' });
        break;
      case 'superAdmin':
        actions.push({ action: 'empty' });
        break;
    }
    if (user.value.role === 'superAdmin') actions.push({ icon: 'fa-solid fa-pen', text: 'Editer', action: 'edit' });
    const fields = [
      { title: 'Nom', value: item.firstname + ' ' + item.lastname },
      { title: 'E-mail', value: item.email  },
      { title: 'Entreprise', value: item.companyName  },
    ]
    return { id: item.id, bubble: item.firstname[0]+item.lastname[0], fields: fields, actions: actions, role: item.role, responsableId: item.responsableId };
  });
});

const getUsers = () => {
  if (route.params.folderId) {
    usersStore.getUsersByFolder(String(route.params.folderId)).then((response: AxiosResponse) => {
      if (response.status === 200) {
        users.value = response.data;
      }
    });
  } else {
    usersStore.getAllUsers().then((response) => {
      if (response.status === 200) {
        users.value = response.data;
      }
    });
  }
}

const createUserSuccess = () => {
  createUserModale.value = '';
  getUsers();
}

const createUser = () => {
  if (user.value.role === 'admin' || user.value.role === 'superAdmin') createUserModale.value = 'manager';
  else createUserModale.value = 'user';
}

const createAdmin = () => {
  createUserModale.value = 'admin';
}

const linkFolders = (user: string) => {
  userObj.value = user;
  isLinkUserOpen.value = true;
};

const changeLogin = (id: string) => {
  userId.value = id;
  isChangeLoginOpen.value = true;
};

const deleteUser = (userId: string): void => {
  usersStore.deleteAdmin(userId).then(() => getUsers());
};

const deleteAll = async () => {
  for (const userId of usersCheck.value) {
    const tmpUser = users.value.find((user) => user.id === userId.id);
    if (tmpUser) await usersStore.deleteAdmin(tmpUser.id);
  }
  getUsers();
}

const toggleUsersCheck = () => {
  if (usersCheck.value.length === 0) {
    usersToDisplay.value.forEach((user: any) => arrayToggleBaseOnId(usersCheck.value, user));
  } else {
    usersCheck.value = [];
  }
};

watch(route, () => {
  getUsers();
});

onMounted(() => {
  getUsers();
});

return (_ctx: any,_cache: any) => {
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, {
      icone: "fas fa-users",
      title: "Listes des utilisateurs",
      displayCurrentFolder: ""
    }),
    _createElementVNode("div", {
      class: _normalizeClass(['sqg-users__board', {'-loading': _unref(userLoader)}])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(user).role !== 'gestionnaireDeDossier')
          ? (_openBlock(), _createBlock(CardButton, {
              key: 0,
              width: "25",
              height: "96",
              class: "sqg-formsNavigation__submit clickable",
              icon: "fas fa-user",
              text: "Ajouter un collaborateur",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (createUserModale.value = 'user'))
            }))
          : _createCommentVNode("", true),
        (_unref(user).role === 'admin' || _unref(user).role === 'superAdmin')
          ? (_openBlock(), _createBlock(CardButton, {
              key: 1,
              width: "25",
              height: "96",
              class: "sqg-formsNavigation__submit clickable",
              icon: "fas fa-user-tie",
              text: "Ajouter un responsable",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (createUserModale.value = 'manager'))
            }))
          : _createCommentVNode("", true),
        (_unref(user).role === 'superAdmin')
          ? (_openBlock(), _createBlock(CardButton, {
              key: 2,
              width: "25",
              height: "96",
              class: "sqg-formsNavigation__submit clickable",
              icon: "fas fa-user-secret",
              text: "Ajouter un administrateur",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (createUserModale.value = 'admin'))
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_unref(userLoader))
          ? (_openBlock(), _createBlock(Card, {
              key: 0,
              width: "100",
              height: "48"
            }, {
              default: _withCtx(() => [
                _createVNode(Loader, { size: "36" })
              ]),
              _: 1
            }))
          : (_unref(user).role === 'admin' || _unref(user).role === 'superAdmin')
            ? (_openBlock(), _createBlock(CardFilter, {
                key: 1,
                width: "100",
                height: "80px",
                title: "Sarah",
                number: users.value.filter((user) => user.role === 'superAdmin').length,
                icone: "fas fa-crown",
                isActive: isActive(['superAdmin']),
                onFilter: _cache[3] || (_cache[3] = ($event: any) => (filterBy(['superAdmin'])))
              }, null, 8, ["number", "isActive"]))
            : _createCommentVNode("", true),
        (_unref(userLoader))
          ? (_openBlock(), _createBlock(Card, {
              key: 2,
              width: "100",
              height: "48"
            }, {
              default: _withCtx(() => [
                _createVNode(Loader, { size: "36" })
              ]),
              _: 1
            }))
          : (_unref(user).role === 'admin' || _unref(user).role === 'superAdmin')
            ? (_openBlock(), _createBlock(CardFilter, {
                key: 3,
                width: "100",
                height: "80px",
                title: "Administrateur",
                number: users.value.filter((user) => user.role === 'admin').length,
                icone: "fas fa-user-secret",
                isActive: isActive(['admin']),
                onFilter: _cache[4] || (_cache[4] = ($event: any) => (filterBy(['admin'])))
              }, null, 8, ["number", "isActive"]))
            : _createCommentVNode("", true),
        (_unref(userLoader))
          ? (_openBlock(), _createBlock(Card, {
              key: 4,
              width: "100",
              height: "48"
            }, {
              default: _withCtx(() => [
                _createVNode(Loader, { size: "36" })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(CardFilter, {
              key: 5,
              width: "100",
              height: "80px",
              title: "Responsable",
              number: users.value.filter((user) => user.role === 'responsable').length,
              icone: "fas fa-user-tie",
              isActive: isActive(['responsable']),
              onFilter: _cache[5] || (_cache[5] = ($event: any) => (filterBy(['responsable'])))
            }, null, 8, ["number", "isActive"])),
        (_unref(userLoader))
          ? (_openBlock(), _createBlock(Card, {
              key: 6,
              width: "100",
              height: "48"
            }, {
              default: _withCtx(() => [
                _createVNode(Loader, { size: "36" })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(CardFilter, {
              key: 7,
              width: "100",
              height: "80px",
              title: "Collaborateur",
              number: users.value.filter((user) => user.role === 'gestionnaireDeDossier').length,
              icone: "fas fa-user",
              isActive: isActive(['gestionnaireDeDossier']),
              onFilter: _cache[6] || (_cache[6] = ($event: any) => (filterBy(['gestionnaireDeDossier'])))
            }, null, 8, ["number", "isActive"]))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(Card, {
          width: "100",
          height: "40",
          class: "sqg-users__search"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createVNode(Input, {
              type: "text",
              placeholder: "Rechercher par nom ...",
              modelValue: searchTerm.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((searchTerm).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(Checkbox, {
            id: "selectAll",
            checked: usersCheck.value.length === _unref(usersToDisplay).length,
            onOnChange: _cache[8] || (_cache[8] = ($event: any) => (toggleUsersCheck()))
          }, null, 8, ["checked"]),
          _createElementVNode("strong", null, "( " + _toDisplayString(usersCheck.value.length) + " )", 1),
          _hoisted_8
        ]),
        (usersCheck.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_Popper, {
                arrow: true,
                hover: true,
                content: "Supprimer tous les éléments"
              }, {
                default: _withCtx(() => [
                  (_unref(user).role === 'superAdmin' && _unref(isActionAvailable)(usersCheck.value, 'remove'))
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: "fas fa-trash-alt clickable",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (deleteAll()))
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_unref(userLoader))
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (user, index) => {
                return _createVNode(TableItemSkeleton, {
                  key: index,
                  fields: [{}, {}, {}, {}],
                  actions: [{}]
                })
              }), 64))
            ]))
          : _createCommentVNode("", true),
        (!_unref(userLoader))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_unref(usersToDisplay).length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(usersToDisplay), (user, index) => {
                      return (_openBlock(), _createBlock(TableItem, {
                        key: user.id,
                        item: user,
                        isCheck: _unref(arrayHasBasedOnId)(usersCheck.value, user),
                        onLink: ($event: any) => (linkFolders(user)),
                        onView: ($event: any) => (_ctx.$router.push({ name: 'User', params: { id: user.id }})),
                        onRemove: ($event: any) => (deleteUser(user.id)),
                        onEdit: ($event: any) => (changeLogin(user.id)),
                        onCheck: _cache[10] || (_cache[10] = ($event: any) => (_unref(arrayToggleBaseOnId)(usersCheck.value, $event)))
                      }, null, 8, ["item", "isCheck", "onLink", "onView", "onRemove", "onEdit"]))
                    }), 128))
                  ]))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (createUserModale.value === 'manager')
      ? (_openBlock(), _createBlock(CreateManager, {
          key: 0,
          onClose: _cache[11] || (_cache[11] = ($event: any) => (createUserModale.value = '')),
          onCreateUser: createUserSuccess
        }))
      : _createCommentVNode("", true),
    (createUserModale.value === 'user')
      ? (_openBlock(), _createBlock(CreateClient, {
          key: 1,
          onClose: _cache[12] || (_cache[12] = ($event: any) => (createUserModale.value = '')),
          onCreateUser: createUserSuccess
        }))
      : _createCommentVNode("", true),
    (createUserModale.value === 'admin')
      ? (_openBlock(), _createBlock(CreateAdmin, {
          key: 2,
          onClose: _cache[13] || (_cache[13] = ($event: any) => (createUserModale.value = '')),
          onCreateUser: createUserSuccess
        }))
      : _createCommentVNode("", true),
    (isLinkUserOpen.value)
      ? (_openBlock(), _createBlock(LinkUserToFolders, {
          key: 3,
          user: userObj.value,
          onClose: _cache[14] || (_cache[14] = ($event: any) => (isLinkUserOpen.value = false))
        }, null, 8, ["user"]))
      : _createCommentVNode("", true),
    (isChangeLoginOpen.value)
      ? (_openBlock(), _createBlock(ChangeLogin, {
          key: 4,
          userId: userId.value,
          onClose: _cache[15] || (_cache[15] = ($event: any) => (isChangeLoginOpen.value = false))
        }, null, 8, ["userId"]))
      : _createCommentVNode("", true)
  ]))
}
}

})